export function localSignOut(instance) {
    try {
        const accounts = instance.getAllAccounts();
        accounts.forEach(acc => instance.removeAccount(acc));
        instance.setActiveAccount(null);
    } catch (e) {
        console.warn('[localSignOut] erro ao limpar contas MSAL', e);
    }
    // Limpa marcadores da sua app
    sessionStorage.removeItem('jwtExchanged');
    sessionStorage.removeItem('authDenied');
}
